export function getHeroParent(
  clickedElement: HTMLElement,
  clickedText: string
): { clicked: string; parent?: string } | null {
  const heroContainer = clickedElement.closest(
    '.d-flex.hero-home-text-container.flex-column'
  );
  if (!heroContainer) {
    return null;
  }

  const heroTitle =
    heroContainer
      .querySelector('.card-title.brand-head-home')
      ?.textContent?.trim() || '';
  return {
    clicked: clickedText,
    parent: clickedText === heroTitle ? undefined : heroTitle
  };
}

/**
 * Extracts hero parent information from clicked element
 * @param clickedElement - The HTML element that was clicked
 * @param clickedText - The text content of the clicked element
 * @returns Object with clicked text and optional parent, or null if not a hero element
 */
export function getNonHeroParent(
  clickedElement: HTMLElement,
  clickedText: string
): { clicked: string; parent?: string } {
  const parentHeader =
    clickedElement
      .closest('a')
      ?.querySelector('.card-headertxt')
      ?.textContent?.trim() || '';
  return {
    clicked: clickedText,
    parent: clickedText === parentHeader ? undefined : parentHeader
  };
}
